import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ChevronUp from 'mdi-react/ChevronUpIcon';
import ChevronDown from 'mdi-react/ChevronDownIcon';

import * as S from './styles';

const VisibilityToggle = ({ active, styling, onToggle, label, chip }) => (
  <S.ToggleVisibilityButton
    color="primary"
    chip={chip}
    size={styling === 'small' ? 'small' : 'medium'}
    variant={!active || styling === 'default' ? 'outlined' : 'default'}
    onClick={() => onToggle(!active)}
    icon={active ? <ChevronUp /> : <ChevronDown />}
    iconPosition="right"
  >
    {label}
  </S.ToggleVisibilityButton>
);

VisibilityToggle.propTypes = {
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  styling: PropTypes.oneOf(['default', 'small']),
  active: PropTypes.bool,
  chip: PropTypes.bool,
};

VisibilityToggle.defaultProps = {
  styling: 'default',
  active: false,
  chip: false,
};

export default memo(VisibilityToggle);
